module.exports = __webpack_public_path__ + "static/media/step3.c16fcbb8.svg";